import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import FullJobList from '../components/FullJobList';
import { LegacyJob } from '../types';

// 使用 LegacyJob 类型用于向后兼容
type Job = LegacyJob;

const JobListPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // 从 URL 参数获取筛选条件
  const initialTypeFilter = searchParams.get('type') || undefined;
  const initialWorkStyleFilter = searchParams.get('workStyle') || undefined;
  const searchQuery = searchParams.get('q') || undefined;

  const handleBack = () => {
    navigate('/');
  };

  const handleSelectJob = (job: Job) => {
    navigate(`/jobs/${job.id}`);
  };

  return (
    <FullJobList
      onBack={handleBack}
      onSelectJob={handleSelectJob}
      initialTypeFilter={initialTypeFilter}
      initialWorkStyleFilter={initialWorkStyleFilter}
      searchQuery={searchQuery}
    />
  );
};

export default JobListPage;
